export * from './wizeMessagingAPI.service';
import { WizeMessagingAPIService } from './wizeMessagingAPI.service';
export const APIS = [WizeMessagingAPIService];
